import { render, staticRenderFns } from "./Movimiento-entre-sucursales.vue?vue&type=template&id=07e54b59"
import script from "./Movimiento-entre-sucursales.vue?vue&type=script&lang=js"
export * from "./Movimiento-entre-sucursales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports